export default "__VITE_ASSET__hS20IuJ8__"